// src/pages/Cancel.js
import React from "react";
import { Link } from "react-router-dom";

export default function Cancel() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#f6f3f2] flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-center">
        <h1 className="text-3xl font-extrabold text-red-600 mb-3">
          Zahlung abgebrochen
        </h1>
        <p className="text-gray-700 mb-4 leading-relaxed">
          Sie haben den Bezahlvorgang abgebrochen oder er wurde nicht
          abgeschlossen. Es wurde kein Betrag abgebucht.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          Wenn Sie den Georeport dennoch erwerben möchten, können Sie den
          Vorgang jederzeit erneut starten.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/report"
            className="inline-flex justify-center px-6 py-3 rounded-full bg-blue-600 text-white font-semibold shadow-md hover:bg-blue-700 transition text-sm"
          >
            Erneut versuchen
          </Link>
          <Link
            to="/"
            className="inline-flex justify-center px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition text-sm"
          >
            Zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
